/**
 * Story beats around the end of a mission (content/reports.ts), remembered on this device: whether
 * the first mission report (with its explanation) was shown, and the beat waiting for the elevator.
 * "Start over" clears both (game/reset.ts clears every game key).
 */
const REPORTED = 'foe-names.reported.v1';
const BEAT = 'foe-names.beat.v1';

export type ElevatorBeat = 'next' | 'allDone';

function get(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function put(key: string, value: string | null) {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch {
    // Storage blocked: beats last for this visit only.
  }
}

/** The first mission report (with its explanation) has been shown. */
export const reportedBefore = () => get(REPORTED) === 'yes';
export const markReported = () => {
  put(REPORTED, 'yes');
};
/** Debug: the next mission report is the first one again (with its explanation). */
export const forgetReported = () => {
  put(REPORTED, null);
};

/** The story beat for the elevator, kept until it is told. */
export const setElevatorBeat = (beat: ElevatorBeat) => {
  put(BEAT, beat);
};
export function peekElevatorBeat(): ElevatorBeat | null {
  const beat = get(BEAT);
  return beat === 'next' || beat === 'allDone' ? beat : null;
}
/** The beat was told. */
export const clearElevatorBeat = () => {
  put(BEAT, null);
};
